import { RemoteReschedulePushNotification } from 'data/usecases';
import { ReschedulePushNotificationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlReschedulePushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeReschedulePushNotification =
  (): ReschedulePushNotificationUseCaseInterface =>
    new RemoteReschedulePushNotification(
      makeApiUrlReschedulePushNotification(),
      makeAxiosHttpClient(),
    );
